import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
} from "@mui/material";

const InfoCard = ({ icon, title, value, color = "primary" }) => {
  const getColorByType = (colorType) => {
    const colors = {
      primary: "#ff9800",
      secondary: "#ff9800",
      success: "#4caf50",
      info: "#2196f3",
      warning: "#ff9800",
    };
    return colors[colorType] || "#ff9800";
  };

  return (
    <Card
      variant="outlined"
      sx={{
        height: "100%",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          boxShadow: { xs: 1, md: 2 },
          transform: { xs: "none", md: "translateY(-2px)" },
        },
        borderRadius: { xs: 1.5, md: 2 },
      }}
    >
      <CardContent sx={{ p: { xs: 1.5, md: 2 } }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: { xs: 0.5, md: 1 },
            mb: { xs: 0.5, md: 1 },
          }}
        >
          {React.cloneElement(icon, {
            sx: {
              color: getColorByType(color),
              fontSize: { xs: "1rem", md: "1.2rem" },
            },
          })}
          <Typography
            variant="caption"
            sx={{
              color: getColorByType(color),
              fontWeight: 600,
              textTransform: "uppercase",
              fontSize: { xs: "0.6rem", md: "0.75rem" },
            }}
          >
            {title}
          </Typography>
        </Box>
        <Typography
          variant={{ xs: "body2", md: "body1" }}
          fontWeight={500}
          sx={{
            wordBreak: "break-word",
            fontSize: { xs: "0.875rem", md: "1rem" },
            lineHeight: { xs: 1.3, md: 1.5 },
          }}
        >
          {value || "-"}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default InfoCard;